//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["controlItem"],
  data() {
    return {
      capture: "",
      fileList: []
    };
  },

  computed: {
    cellClass: function() {
      return {
        "van-cell": true,
        "van-field": true,
        "van-cell--required": this.controlItem.IsRequired
      };
    }
  },
  created() {
    console.log("controlItem.ControlValue", this.controlItem.ControlValue);

    if(this.controlItem.ControlValue){
      this.fileList = this.controlItem.ControlValue.map(m => {
        return { url: m };
      });
    }
    

    this.capture = this.getCamera();

    console.log("this.capture", this.capture);

    this.controlItem.getValue = () => {
      return this.getValue();
    };
  },
  methods: {
    getCamera() {
      if (
        this.controlItem &&
        this.controlItem.ExtConfig &&
        this.controlItem.ExtConfig.IsCamera
      ) {
        return "camera";
      }
      return null;
    },

    getValue() {
      if (!this.controlItem) return null;

      if (!this.controlItem.ControlValue) return null;

      // if (this.controlItem.ControlValue.length == 0) return null;
      console.log("1111111111111111111111111");
      var serverUrlList = this.fileList.map(m => {
        console.log("fileList--m", m);
        if (m && m.file && m.file.ServerUrl) {
          console.log("m.file.ServerUrl", m.file.ServerUrl);
          return m.file.ServerUrl;
        }

        if (m && m.url) {
          return m.url;
        }
      });

      if (serverUrlList && serverUrlList.length > 0) {
        return serverUrlList;
      }
      return null;
    },

    initForm() {
      if (this.controlItem && !this.controlItem.ControlValue) {
        this.controlItem.ControlValue = [];
      }
    },

    onUploaderBeforeRead(file, detailItem) {
      console.log("onUploaderBeforeRead --detailItem", file, detailItem);
      this.$msg.loading("上传中...");
      // if (file.type !== "image/jpeg") {
      //   //Toast('请上传 jpg 格式图片');
      //   return false;
      // }
      // this.uploadFile(file,detailItem);
      // this.uploadImg(file)
      return true;
    },
    //图片压缩
    uploadImg(file) {
      // 大于0.1MB的jpeg和png图片都缩小像素上传
      if (/\/(?:jpeg|png)/i.test(file.file.type) && file.file.size > 100000) {
        // 创建Canvas对象(画布)
        let canvas = document.createElement("canvas");
        // 获取对应的CanvasRenderingContext2D对象(画笔)
        let context = canvas.getContext("2d");
        // 创建新的图片对象
        let img = new Image();
        // 指定图片的DataURL(图片的base64编码数据)
        img.src = file.content;
        // 监听浏览器加载图片完成，然后进行进行绘制
        img.onload = () => {
          // 指定canvas画布大小，该大小为最后生成图片的大小
          console.log(img.width, img.height);
          canvas.width = img.width / 4;
          canvas.height = img.height / 4;
          /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。
        如果不指定缩小的像素图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后的图片就是张局部图。*/

          context.drawImage(img, 0, 0, img.width / 4, img.height / 4);
          // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
          file.content = canvas.toDataURL(file.file.type, 0.92);
          // 最后将base64编码的图片保存到数组中，留待上传。
          // this.imgBase64.push(file.content)
          this.uploadFile(file.file);
        };
      } else {
        // 不做处理的jpg和png以及gif直接保存到数组
        this.uploadFile(file.file);
        // if(this.imgBase64.length < 6) {
        //   this.imgBase64.push(file.content)
        // }else{
        //   alert("最多上传6张图片")
        // }
      }
    },
    onUploaderAfterRead(file) {
      console.log(file, "filefilefilefilefile");
      this.uploadImg(file);
    },

    uploadFile(file, detailItem) {
      console.log(file, "zzzzz");
      if (file) {
        this.$msg.loading("上传中...");
        var fr = new FileReader();
        fr.readAsDataURL(file);
        fr.onload = () => {
          this.$msg.loading("上传中...");
          var base_url = fr.result
            .replace("data:image/png;base64,", "")
            .replace("data:image/jpg;base64,", "")
            .replace("data:image/jpeg;base64,", "");
          var formData = new FormData();
          formData.append("url", base_url);
          //console.log("base_url", base_url);
          var url = "File/UploadStreamFile";

          this.$http({
            url: url,
            method: "post",
            headers: {
              "Content-Type": "multipart/form-data"
            },
            data: formData
          })
            .then(res => {
              this.$msg.hideLoading();
              var result = res.data;
              if (result.state == 1) {
                this.$msg.succ("文件上传成功.");
                var imgSrc = result.data.src;
                file.ServerUrl = imgSrc;
                //console.log("controlItem.ControlValue",this.controlItem.ControlValue);
                //this.controlItem.ControlValue = imgSrc;
                var value = this.getValue();
                console.log("this.getValue()", value);
                return;
              }
              this.$msg.alert(res.data.msg);
            })
            .catch(err => {
              this.$msg.hideLoading();
            });
        };
      }

      this.$msg.hideLoading();
    }
  }
};
